import { Routes, Route } from 'react-router-dom'
import React from 'react'
// Protection public and private routes
import PublicRoutes from './guards/PublicRoutes'
import PrivateRoutes from './guards/PrivateRoutes'

//Import de la liste des pages
import NotFound from '../pages/Errors/NotFound'
import LoginPage from '../pages/Login/LoginPage'
import LogoutPage from '../pages/Logout/LogoutPage'
import Sandbox from '../pages/Sandbox/Sandbox'
import Workspaces from '../pages/Workspaces/Workspaces'
import CreateForm from '../pages/CreateForm/CreateForm'
import FieldProvider from '../pages/Sandbox/components/store/FieldContext'
import Permission from '../pages/Errors/Permission'
import FormBuilder from '../pages/FormBuilder/FormBuilder'
import ViewForm from '../pages/ViewForm/ViewForm'
import PreviewForm from '../pages/PreviewForm/PreviewForm'
import Answers from '../pages/Answers/Answers'
import TestBuilder from '../pages/TestBuilder/TestBuilder'
import DesignerBuilder from '../pages/DesignerBuilder/DesignerBuilder'
import Home from '../pages/Home/Home'
import AnswersV2 from '../pages/AnswersV2/AnswersV2'
import AnswersV3 from '../pages/AnswersV3/AnswersV3'
import Test from '../pages/Test/Test'
import CallbackPage from '../pages/CallbackPage/CallbackPage'
import Tester from '../pages/Tester/Tester'

// AUTHORIZATIONS
import AuthorizationGuard from '../pages/Sandbox/components/AuthorizationGuard/AuthorizationGuard'
import AuthorizationGuardViewForm from '../pages/ViewForm/components/AuthorizationGuard/AuthorizationGuardViewForm'

// Store mobX
import { AnswersProvider } from '../pages/AnswersV3/components/store/store.Answers'
import { DesignerBuilderProvider } from '../pages/DesignerBuilder/components/store/store.DesignerBuilder'
import { BuilderProvider } from '../pages/Sandbox/components/store/store.Builder'
import { ViewFormProvider } from '../pages/ViewForm/components/store/store.ViewForm'
import { FormBuilderProvider } from '../pages/FormBuilder/store/store.FormBuilder'

function AppRoutes() {
  return (
    <Routes>
      <Route path="/forbiden" element={<Permission />} />
      <Route index element={<LoginPage />} />

      <Route element={<PublicRoutes />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/callback" element={<CallbackPage />} />
        <Route
          path="/viewform/:url_code"
          element={
            <ViewFormProvider>
              <AuthorizationGuardViewForm>
                <ViewForm />
              </AuthorizationGuardViewForm>
            </ViewFormProvider>
          }
        />
      </Route>

      <Route element={<PrivateRoutes />}>
        <Route path="/workspaces" element={<Workspaces />} />

        <Route path="/home" element={<Home />} />

        <Route path="/test" element={<Test />} />

        <Route path="/tester" element={<Tester />} />

        <Route
          path="/testbuilder"
          element={
            <DesignerBuilderProvider>
              <TestBuilder />
            </DesignerBuilderProvider>
          }
        />

        <Route path="/create-form" element={<CreateForm />} />

        <Route
          path="/Fbuilder/:url_code/*"
          element={
            <DesignerBuilderProvider>
              <Routes>
                <Route path="/" element={<DesignerBuilder />} />
              </Routes>
            </DesignerBuilderProvider>
          }
        />

        <Route
          path="/builder/:url_code/*"
          element={
            <FormBuilderProvider>
              <Routes>
                <Route path="/" element={<FormBuilder />} />
              </Routes>
            </FormBuilderProvider>
          }
        />

        <Route
          path="/sandbox/:url_code/*"
          element={
            <BuilderProvider>
              <AnswersProvider>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <AuthorizationGuard>
                        <Sandbox />
                      </AuthorizationGuard>
                    }
                  />
                  <Route
                    path="/preview"
                    element={
                      <ViewFormProvider>
                        <AuthorizationGuard>
                          <PreviewForm />
                        </AuthorizationGuard>
                      </ViewFormProvider>
                    }
                  />
                  <Route
                    path="/answers"
                    element={
                      <AuthorizationGuard>
                        <ViewFormProvider>
                          <AnswersV3 />
                        </ViewFormProvider>
                      </AuthorizationGuard>
                    }
                  />
                  <Route
                    path="/answers2"
                    element={
                      <AuthorizationGuard>
                        <ViewFormProvider>
                          <AnswersV2 />
                        </ViewFormProvider>
                      </AuthorizationGuard>
                    }
                  />
                  <Route
                    path="/answers3"
                    element={
                      <AuthorizationGuard>
                        <ViewFormProvider>
                          <AnswersV3 />
                        </ViewFormProvider>
                      </AuthorizationGuard>
                    }
                  />
                </Routes>
              </AnswersProvider>
            </BuilderProvider>
          }
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes
